
module fdm.flightEvents {

    export class flightEventsPerFlightPhaseController {


        public queryResult: any;
        public query: any;
        public data: any;
        public layout: any;
        public options: any;
        public events: any;
        public loading: any;
        private xItems: Array<string> = [];
        private xItemsPlaceholder: Array<string> = [];

        public constructor(
            private actionService: dg.actions.ActionService,
            private $scope: any,
            private navigationService: dg.navigation.NavigationService,
            private chartService: dg.lists.ChartService,
            private uiService: dgUtils.UiService,
            private severityLevelService: SeverityLevelService) {

        }

        $onChanges(changes) {
            if (changes.queryResult && changes.queryResult.currentValue) {
                this.xItems = [];
                this.xItemsPlaceholder = [];
                this.generateChart();
            }
        }

        public generateChart = () => {

            let minorLevels: Array<number> = [];
            let majorLevels: Array<number> = [];
            let criticalLevels: Array<number> = [];

            for (let i = 0; i < this.queryResult.items.length; i += 1) {
                let item = <iteraFDM.domain.flightEvents.FlightPhaseEventsInfo>this.queryResult.items[i];
                this.xItems.push(item.phase.id);
                this.xItemsPlaceholder.push((<any>item.phase).description);
                minorLevels.push(item.minorCount);
                majorLevels.push(item.majorCount);
                criticalLevels.push(item.criticalCount);
            }

            var minorLevelsBar = {
                x: this.xItems,
                y: minorLevels,
                marker: {
                    color: this.severityLevelService.getColor("Minor")
                },
                type: 'bar',
                name: 'Minor'
            }

            var majorLevelsBar = {
                x: this.xItems,
                y: majorLevels,
                marker: {
                    color: this.severityLevelService.getColor("Major")
                },
                type: 'bar',
                name: 'Major'
            }

            var criticalLevelsBar = {
                x: this.xItems,
                y: criticalLevels,
                marker: {
                    color: this.severityLevelService.getColor("Critical")
                },
                type: 'bar',
                name: 'Critical'
            }

            this.data = [minorLevelsBar, majorLevelsBar, criticalLevelsBar];
            this.layout = {
                hovermode: 'closest',
                barmode: 'group',
                height: 359,
                bargap: 0.37,
                showlegend: false,
                //legend: {
                //    xanchor: "right",
                //    yanchor: "top",
                //    orientation: "h",
                //    y: 10,
                //    font: {
                //        //family: 'sans-serif',
                //        //size: 11,
                //        //color: '#686868'
                //    },
                //    x: 1
                //},
                margin: {
                    t: 10,
                    b: 20,
                    l: 45,
                    r: 30
                },
                xaxis: {
                    type: 'category',
                    fixedrange: true,
                    tickfont: {
                        //family: "serif",
                        //size: 11,
                        //color: "#666666"
                    },
                },
                yaxis: {
                    autotick: true,
                    fixedrange: true,
                    rangemode: 'nonnegative'
                }
            };

            this.options = {
                showLink: false,
                displayLogo: false,
                displayModeBar: false,
                //staticPlot: true
            };

            this.events = (graph) => {

                graph.on('plotly_click', (eventData) => {

                    if (eventData.points && eventData.points[0] && eventData.points[0].data) {
                        let phaseName = eventData.points[0].x;
                        let level = eventData.points[0].data.name;

                        //console.log(eventData);
                        let link = this.uiService.getLinkByPropertyAndLevel('phase', phaseName, level, this.queryResult);
                        this.navigationService.navigate(link, this.query);
                    }
                });

                //graph.on('plotly_click', (data) => {
                //    if (data.points) {
                //        let name = data.points[0].x;
                //        let link = this.uiService.getLinkByProperty('phase', name, this.queryResult);
                //        this.navigationService.navigate(link, this.query);
                //    }
                //});

                //graph.on('plotly_hover', (eventData) => {
                //    let infoText = this.chartService.getItemByIndex(eventData, this.xItems, this.xItemsPlaceholder);

                //    this.chartService.setPlaceholderText(infoText, eventData.points[0].x);
                //});
            };
        }

        //public getLinkByProperty(property: string, phaseName: string, queryResult: any) {
        //     for (let i = 0; i < queryResult.items.length; i += 1) {
        //         if (queryResult.items[i][property].displayValue == phaseName) {
        //             return queryResult.items[i].dgMeta.links.viewEvents;
        //         }
        //     }
        // }
    }


    angular.module('fdm.flightEvents').component('flightEventsPerFlightPhase', {
        bindings: {
            queryResult: '<',
            loading: '<',
            query: '<'
        },
        controller: flightEventsPerFlightPhaseController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart-instance.html'
    });
}